import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { ClaimGroupReasonValues } from '../NewClaimGroupReasonPage.types';

export const useRefreshFormSchemaOnReasonChange = (
  formContext: UseFormReturn<ClaimGroupReasonValues>,
) => {
  const reason = formContext.watch('reason');

  useEffect(() => {
    if (reason) {
      formContext.trigger('reason');
    }
  }, [formContext, formContext.trigger, reason]);
};
